import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {timer, BehaviorSubject, Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {Message} from '../class/message';
import {ContractService} from './contract.service';
import {CommonService} from './common.service';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

const routes = {
  filterTest: '/enterprise/document-type/filter',
  filter: '/contract/filter',
  filterMine: '/contract/filter-mine',
  filterReceiveMine: '/contract/filter-receive-mine',
  filterWaitSign: '/contract/wait-sign/filter',
  filterWaitSignDigital: '/contract-employment/digital/wait-sign/filter',
  filterWaitSignApprove: '/contract/wait-sign-approve/filter',
  filterWaitSignInitial: '/contract/wait-sign-initial/filter',
  filterWaitConfirm: '/contract/wait-approve/filter',
  filterChild: '/contract/sub/filter/',
  filterReceive: '/contract/side-take/filter',
  filterChildReceive: '/contract/sub/side-take/filter',
  filterContractCompany: '/contract-employment/filter-company',
  filterWaitSignMoha: '/contract-employment/digital/wait-sign/filter',
  filterDigital: '/contract-employment/digital/filter',
  filterWaitSignApproveDigital: '/contract-employment/digital/wait-sign-approve/filter',
  filterContractStandardized: '/contract-employment/review-standardized-contract/filter-standardized',
  reviewStandardized: '/contract-employment/review-standardized-contract/filter',
  addContractStandardized: '/contract-employment/review-standardized-contract/add',
  filterContractStandardizedExecute: '/contract-employment/review-standardized-contract/filter-standardized-search',
  standardizedNotes: (id: string) => `/contract-employment/standardized-notes/${id}`,

  serviceTypes: (id: any) => `/common/enterprise/service-type/${id}`,
  parentIds: (code: any) => `/enterprise/document/parent/${code}`,
  changeStatus: (id: string) => `/enterprise/document/change-status/${id}`,
  setAutoSign: (id: string) => `/enterprise/document/set-auto-sign/${id}`,
  getDocumentTypeById: (id: string) => `/file/viewDocTypeEtpHtml/${id}`,
  createDocumentByTemplate: () => `/contract/`,
  updateDocumentByTemplate: () => `/contract/form/update`,
  deleteAll: () => '/contract/delete-all',
  delete: (id: string) => `/contract/delete/${id}`,
  document: (id: string) => `/contract/detail/${id}`,
  updateDocument: '/contract/file/update',
  signers: (id: string) => `/users/signers/${id}`,
  getDocumentReferById: (id: string) => `/contract/relation/${id}`,
  viewContractPdf: (id: string) => `/contract/viewContractPdf/${id}`,
  sendContract: (id: string) => `/contract/send-contract/${id}`,
  startSignFlow: (id: string) => `/contract/start-sign-flow/${id}`,
  createHash: () => `/digital-signature/generate-hash`,
  createHashWithImage: (signLot?: boolean) => `/digital-signature/generate-hash-image${signLot ? '?signLot=true' : ''}`,
  createHashWithImageMoha: (signLot?: boolean) => `/moha-report/generate-hash-image${signLot ? '?signLot=true' : ''}`,
  createHashNoImage: (signLot ?: boolean) => `/digital-signature/generate-hash-no-image${signLot ? '?signLot=true' : ''}`,
  createMultiHashNoImage: (signLot ?: boolean) => `/digital-signature/multi-generate-hash-no-image${signLot ? '?signLot=true' : ''}`,
  createMultiApproveHashNoImage: (signLot ?: boolean) => `/digital-signature/multi-approve-generate-hash-no-image${signLot ? '?signLot=true' : ''}`,
  createMultiHashImage: (signLot ?: boolean) => `/digital-signature/multi-generate-hash-image${signLot ? '?signLot=true' : ''}`,
  createMultiApproveHashImage: (signLot ?: boolean) => `/digital-signature/multi-approve-generate-hash-image${signLot ? '?signLot=true' : ''}`,
  createMultiApproveAppendNoCert: () => `/digital-signature/sign-batch/sign-approve-usb-token-multi-append-no-cert`,
  usbTokenInitSignGroup: () => `/digital-signature/usb-token-init-sign-group`,
  usbTokenInitApproveGroup: () => `/digital-signature/usb-token-init-sign-approve-group`,
  createHashDirectly: () => `/digital-signature/generate-hash-directly`,
  // signUsb: () => `/digital-signature/sign/usb-token`,
  signUsb: (signLot ?: boolean) => `/digital-signature/sign/usb-token-multi-pos${signLot ? '?signLot=true' : ''}`,
  signUsbMoha: (signLot ?: boolean) => `/moha-report/sign/usb-token-multi-pos${signLot ? '?signLot=true' : ''}`,
  signBatchUsb: (signLot ?: boolean) => `/digital-signature/sign-batch/usb-token-multi-pos${signLot ? '?signLot=true' : ''}`,
  approveBatchUsb: (signLot ?: boolean) => `/digital-signature/sign-batch/sign-approve-usb-token-multi${signLot ? '?signLot=true' : ''}`,
  signUsbDirectly: () => `/digital-signature/sign/usb-token-directly`,
  getDocumentBySignAll: () => `/contract/wait-sign/all`,
  getDigitalDocumentsBySignAll: () => `/contract/wait-sign-digital/all`,
  getDocumentByApproveAll: () => `/contract/wait-sign-approve/all`,
  submitSignedDocuments: () => `/digital-signature/sign-multi`,
  submitApprovedDocumentsWithoutCertificate: () => '/digital-signature/sign-approve-multi-no-certified',
  submitDeclineDocuments: () => '/digital-signature/decline-sign-approve-multi',
  submitSignMultiCloudCa: () => `/digital-signature/sign-multi-cloud-ca`,
  submitSignMultiSessionCloudCa: () => `/digital-signature/sign-multi-session-cloud-ca`,
  submitSignDigitalMultiCloudCa: () => `/digital-signature/sign-digital-multi-cloud-ca`,
  submitApproveMultiCloudCa: () => `/digital-signature/sign-approve-multi-cloud-ca`,
  submitApproveMultiSessionCloudCa: () => `/digital-signature/sign-approve-multi-session-cloud-ca`,
  getSignSlotStatus: (hasPreviousFlag: boolean) => `/digital-signature/detail-process/${hasPreviousFlag}`,
  getSignWaitSlotStatus: (hasPreviousFlag: boolean) => `/digital-signature/detail-process/${hasPreviousFlag}?type=4`,
  getApproveSlotStatus: (hasPreviousFlag: boolean) => `/digital-signature/detail-process-approve/${hasPreviousFlag}?type=2`,
  getDeclineApprovalSlotStatus: (hasPreviousFlag: boolean) => `/digital-signature/detail-process-approve/${hasPreviousFlag}?type=3`,
  getDigitalSlotStatus: (hasPreviousFlag: boolean) => `/digital-signature/detail-process/${hasPreviousFlag}?type=5`,
  stopSign: () => `/digital-signature/cancel-process`,
  stopSignWait: () => `/digital-signature/cancel-process?type=4`,
  stopSignDigital: () => `/digital-signature/cancel-process?type=5`,
  stopApprove: () => `/digital-signature/cancel-approve-process?type=2`,
  stopDecline: () => `/digital-signature/cancel-approve-process?type=3`,
  cancelSignBatch: () => `/digital-signature/cancel-sign-batch`,
  cancelSignBatchDigital: () => `/digital-signature/cancel-sign-batch?type=5`,
  cancelApproveBatch: () => `/digital-signature/cancel-sign-batch?type=2`,
  uploadMultiFileAttachForDocument: () => '/file/upload/contractAttachment',
  // signAll: `/digital-signature/sign-all-by-filter`,
  // signAllList: `/contract/wait-sign/all`,
  // signById: `/digital-signature/sign-all-by-id`
  checkTemplate: (templateId) => `/contract/checkDocumentEnterprise/${templateId}`,
  rejectDirectly: '/contract/reject-directly',
  cancelSignFlow: '/contract/cancel-sign-flow',
  approvalDocument: '/contract/approval-document',
  approvalDocumentDigital: '/digital-signature/contract-employment/sign/cloud-ca-image-multiple-pos',
  declinedApproveDocument: '/contract/decline-approve-document',
  declinedSignDocument: '/contract/decline-sign-document',
  moneyTransfer: (money ?: boolean) => `/enterprises/transfer-money-tsa-to-sms?money=${money}`,
  moneyTransferCts: (money ?: boolean) => `/enterprises/transfer-money-sms-to-tsa?money=${money}`,
  initialSignDocument: '/contract/initial-sign-document',
  declineInitialSignDocument: '/contract/decline-initial-sign-document',
  getListEnterpriseUserSign: (contractId) => `/contract/${contractId}/list-enteprise-user-sign`,
  getListEnterpriseUserSignForCopy: (contractId) => `/contract/${contractId}/list-enteprise-user-sign-for-copy`,
  updateFileNameAndFileSize: `/contract/updateFileNameAndFileSize`,
  previewOutputFile: `/contract/preview-output-file`,
  getUserProcessByContractId: (id: string) => `/contract/${id}/get-user-processing`,
  sendUserSignContractByContractId: (id: string) => `/contract/${id}/send-sign-contract-notify`,
  retrieveSignLink: (id: string) => `/contract/${id}/retrieve-sign-link`,
  forwardContract: '/contract-shared/forward-shared-config',
  createSignContractFlow: '/sign-lot-flow/start',
  deleteLotCancelFlow: '/cancel-lot-flow/start',
  signatureProcessLotFlow: '/confirm-lot-flow/start',
  signContractFlowInfo: (id: string) => `/import-lot/get-by-id/${id}`,
  signContractFlowProcessing: (id: string) => `/sign-lot-flow/processing/${id}`,
  cancelContractFlow: (id: string) => `/cancel-lot-flow/processing/${id}`,
  confirmContractFlow: (id: string) => `/confirm-lot-flow/processing/${id}`,
  signContractFlowCancel: (id: string) => `/sign-lot-flow/cancel/${id}`,
  CancelContractFlowCancel: (id: string) => `/cancel-lot-flow/cancel/${id}`,
  CancelContractFlowSignProcess: (id: string) => `/confirm-lot-flow/cancel/${id}`,
  createDeleteContractFlow: '/delete-all-draft/start',
  deleteContractFlowProcessing: (id: string) => `/delete-all-draft/processing/${id}`,
  deleteContractFlowCancel: (id: string) => `/delete-all-draft/cancel/${id}`,
  getDeleteContractFlowId: '/delete-all-draft/get-id-lot-in-process',
  saveColumnDynamic: `/user-config/save-user-config`,

  getSignContractFlowId: '/sign-lot-flow/get-id-lot-in-process',
  retrySignFlow: '/digital-signature/sign-transaction/ceca-retry',
  checkTimestampMoney: '/digital-signature/sign-transaction/check-timestamp-money',
  createTimestampMoney: '/digital-signature/sign-transaction/create',
  getListEnterpriseUserSignByTemplateId: (id: string) => `/dc/document-type-enterprises/bind-user-sign/${id}`,
  resetAllDown: '/sign-transaction/reset-all-down',
  getTransactionDown: '/sign-transaction/get-all-down',
  resetDown: '/sign-transaction/reset-down',
  getDownById: '/sign-transaction/get-by-id',
  signGroupDetail: (id: string) => `/digital-signature/sign-group-detail/${id}`,
  checkProcessingContract: () => `/digital-signature/check-processing-contracts`,
  checkProcessingApproveContract: () => `/digital-signature/check-processing-contracts?type=2`,
  fileSignAdminDownload: (id: string) => `/digital-certificate/file-sign-admin-download/${id}`,
  autoGenerateContractCode: '/contract/auto-generate-contract-code',
  getSignImage: '/file/get-sign-image',
  getCustomerProcessing: (contractId) => `/contract/${contractId}/get-customer-processing`,
  getContractUserApprove: (id: any) => `/common/contract-user-approve?contractId=${id}`,
  reSendLinkUserSignContractByContractId: (id: string) => `/contract/${id}/send-contract-notify`,
  addApproverContract: `/contract/add-user-approve`,
  preMultiDownload: `/file/download/pre-multiple-contract-files-zip`,
  preMultiDownloadDigital: `/file/download/pre-multiple-contract-digital-files-zip`,
  multiDownload: (key: string, currentUser: string, lang: string) => `/file/download/multiple-contract-files-zip/${key}?token=${currentUser}&lang=${lang}`,
  multiDownloadDigital: (key: string, currentUser: string, lang: string) => `/file/download/multiple-contract-digital-files-zip/${key}?token=${currentUser}&lang=${lang}`,
  validateSignaturePprocess: '/contract/validate-contract',
  getCertificateLastest: '/digital-signature/get-certificate-lastest',
  resetNumberOtp:(customerId: string, contractId: string) => `/common/reset-number-otp-sending-time/${contractId}/${customerId}`,
  filterLimit: '/contract/filter-limit',
  searchProcessingDocument: '/contract/processing/filter',
  saveContractWithNegotiate: '/contract/negotiate/start',
  continueContractWithNegotiate: '/contract/negotiate/continue',
  commitNegotiate: '/contract/negotiate/comment',
  searchNegotiateDocument: '/contract/negotiate/filter',
  getHistoryNegotiate: '/contract/negotiate/get-comment/',
  downLoadFileNegotiate: '/contract/download-file-negotiate/',
  commitNegotiateAnonymous: '/anonymous/negotiate/comment',
  getHistoryNegotiateAnonymous: '/anonymous/negotiate/get-comment/',
  downLoadFileNegotiateAnonymous: '/anonymous/download-file-negotiate/',
  appParam: '/common/app-param',
  filterContractShare: "/contract/filter-contract-share",
  getListPartnerSharedById: "/contract-share-partner/get-by-contract/",
  updateListPartnerShared: "/contract-share-partner/create-or-update",
  sendUserSignContractLot: '/contract/send-sign-contract-notify-in-batch',
  checkContractTermination: (id: string) => `/contract/check-contract-termination/${id}`,
  checkContractTerminationCopy: (id: string) => `/contract/check-contract-termination-copy/${id}`,
  getInfoFile: `/common/get-info-file-pdf`,
  declinedConfirmDocument: '/contract-employment/digital/reject',
  acceptConfirmDocument: '/contract-employment/digital/confirm',
  downloadFileEvidence: (id : string) => `/contract-employment/moha/evident/${id}`,
  signUsbDigital: '/digital-signature/contract-employment/sign/usb-token',
  getListSmsTemplates: `/service-types/sms-templates`
}
@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private toastr: ToastrService,
    private contractService: ContractService,
    private commonService: CommonService,
    public message: Message) {
  }

  // Use this to emit value when data on display-template changed
  /**
   * interval of calling.
   */
  private static CALL_INTERVAL = 3000;

  /**
   * Finish progress value.
   */
  public static FINISH_PROGRESS_VALUE = 100;

  /**
   * Slot sign no action.
   */
  public static SLOT_SIGN_NO_ACTION = 0;

  /**
   * Slot sign processing
   */
  public static SLOT_SIGN_PROCESSING = 1;

  /**
   * Slot sign finish.
   */
  public static SLOT_SIGN_FINISH = 2;

  /**
   * Slot stop sign.
   */
  public static SLOT_SIGN_STOP = 3;

  /**
   * Done of signing.
   */
  public static STATUS_DONE = 1;

  /**
   * Waint for signing.
   */
  public static STATUS_WAIT = 0;

  /**
   * Fail of signing.
   */
  public static STATUS_FAIL = -1;

  /**
   * DAEMON of signing.
   */
  public static STATUS_DAEMON = 2;
  /***
   * Create new instance.
   */
  private contractFilesSource = new BehaviorSubject(null);
  contractFilesInfo = this.contractFilesSource.asObservable();

  private contractSource = new BehaviorSubject(null);
  contractInfo = this.contractSource.asObservable();

  private cancelFlowSource = new BehaviorSubject(false);
  cancelFlow = this.cancelFlowSource.asObservable();

  public serviceTypeSource = new BehaviorSubject(null);

  public systemSignImage = new BehaviorSubject(null);
  systemSignImage$ = this.systemSignImage.asObservable();

  /**
   * ready to call.
   */
  private isReadyToCalling = true;

  /**
   * Slot request timer.
   */
  private slotRequestTimer: any;
  private resTmp: any;

  /**
   * Stop sign slot flag.
   */
  private isStopSignSlot = false;

  /**
   * update sign action.
   */
  public signUpdateAction = new BehaviorSubject<any>(null);
  public signWaitUpdateAction = new BehaviorSubject<any>(null);
  public approveUpdateAction = new BehaviorSubject<any>(null);
  public declineUpdateAction = new BehaviorSubject<any>(null);
  public signDigitalUpdateAction = new BehaviorSubject<any>(null);
  public isBuyContract10Mb = new BehaviorSubject<boolean>(false);
  public isBuyContract1Mb =  new BehaviorSubject<boolean>(false);
  public signDone = new BehaviorSubject<boolean>(false);
  imageSignature = new BehaviorSubject<any>(null);
  public messageData : string = "";


  /**
   * percent sign progress
   */
  private percent = 0;

  private customerId: any;

  /**
   * Create document for enterprise
   */
  public signPosition = new BehaviorSubject([]);

  public signDataValidate = new BehaviorSubject([]);

  @BlockUI() blockUI: NgBlockUI;

  setImageSignature(imageSignature: any) {
    this.imageSignature.next({
      url: imageSignature && imageSignature.url ? imageSignature.url : '',
      fileUpload: imageSignature && imageSignature.fileUpload ? imageSignature.fileUpload : null
    })
  }

  getImageSignature() {
    return this.imageSignature.asObservable();
  }

  setSignPosition(signPosition: any) {
    this.signPosition.next(signPosition);
  }

  getSignPosition() {
    return this.signPosition.asObservable();
  }

  setSignDataValidate(dataValidate: any) {
    this.signDataValidate.next(dataValidate);
  }

  getSignDataValidate() {
    return this.signDataValidate.asObservable();
  }

  setServiceType(serviceType: any) {
    this.serviceTypeSource.next(serviceType);
  }

  addDocument(document: any, errCallback: any): Observable<any> {
    return this.handleErrCallback(document, errCallback, '/contract/file');
  }
  addQuicklyDocument(document: any, errCallback: any): Observable<any> {
    return this.handleErrCallback(document, errCallback, '/contract/create-quickly');
  }

  checkExistSignfileDocument(files: File[]) {
    if (files.length) {
      const formdata = new FormData();
      files.forEach(file => {
        formdata.append('file', file);
      });
      return this.apiService.postUpload('/contract/exist-signature', formdata)
        .pipe(map(res => {
          return res;
        }));
    } else {
      return new BehaviorSubject({success: true}).asObservable();
    }

  }

  updateFileNameAndFileSize(certificate: any) {
    return this.apiService.post(routes.updateFileNameAndFileSize, certificate);
  }


  updateDocumentUpdload(document: any, callBack: any, noCallBack: any, errCallback?: any) {
    return this.apiService.putAndCheckVersion(
      routes.updateDocument,
      document,
      callBack,
      noCallBack,
      errCallback
    );
  }


  // Get customer Id
  getCustomerId(): any {
    return this.customerId;
  }

  // Set customer Id
  setCustomerId(id): any {
    this.customerId = id;
  }

  testAPI(filter: any) {
    const filterCondition = {
      name: null,
      code: null,
      parentId: null,
      status: null,
      isAutoSign: null,
      page: 0,
      pageSize: 10
    };

    return this.apiService.post(routes.filterTest, filterCondition).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  getCertificateLastest() {
    return this.apiService.get(routes.getCertificateLastest)
    .pipe(map(res => {
      return res;
    }));
  }

  /**
   * Search list document type for enterprise
   * postSilently: khong block UI toan trang, bang tu hien skeleton rieng
   */
  searchDocument(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.postSilently(routes.filter, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  searchDocumentLimit(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.postSilently(routes.filterLimit, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Search list document type for enterprise
   * postSilently: khong block UI toan trang, bang tu hien skeleton rieng
   */
  searchMyDocument(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.postSilently(routes.filterMine, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Search list document type for enterprise
   */
  searchDocumentWaitSign(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.postSilently(routes.filterWaitSign, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Search list document type for enterprise
   */
   searchDocumentWaitSignDigital(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.post(routes.filterWaitSignDigital, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  searchDocumentWaitSignMoha(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.post(routes.filterWaitSignMoha, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  searchDocumentFilterDigital(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.post(routes.filterDigital, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Search list document sign approve
   */
  searchDocumentSignApprove(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.postSilently(routes.filterWaitSignApprove, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Search list document sign approve
   */
   searchDocumentSignApproveDigital(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.post(routes.filterWaitSignApproveDigital, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }


  /**
   * Search list document sign approve
   */
  searchDocumentSignInitial(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.postSilently(routes.filterWaitSignInitial, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Search list document waiting confirm
   */
  searchDocumentWaitingConfirm(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.postSilently(routes.filterWaitConfirm, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  searchDocumentReceive(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.postSilently(routes.filterReceive, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  getReviewStandardized(body) {
    return this.apiService.postSilently(routes.reviewStandardized, body).pipe();
  }


  searchChildDocumentReceive(filter: any) {
    /* return this.apiService.post(routes.filter, filter).pipe( */
    // for testing
    return this.apiService.postSilently(routes.filterChildReceive, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Search list child document type for enterprise
   * postSilently: khong block UI toan trang, bang tu hien icon loading rieng
   */
  searchChildDocument(filter: any) {
    // for testing
    return this.apiService.postSilently(routes.filterChild, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Change status
   */
  changeStatusDocument(id: string) {
    return this.apiService.get(routes.changeStatus(id));
  }

  /**
   * Set auto sign
   */
  setAutoSignDocument(id: string) {
    return this.apiService.get(routes.setAutoSign(id));
  }

  /**
   * Delete document
   */
  delete(id: string) {
    return this.apiService.get(routes.delete(id));
  }

  /**
   * Delete document
   */
  deleteAll(ids: any) {
    return this.apiService.post(routes.deleteAll(), ids);
  }

  /**
   * Find by id
   */
  findById(id: string) {
    return this.apiService.get(routes.delete(id));
  }

  /**
   * Update document type for enterprise
   */
  updateDocument(documentTypeEnterprise: any) {
    return this.apiService.put('/enterprise/document-type', documentTypeEnterprise)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Get ServiceType list
   */
  getServiceTypes(id: any) {
    return this.apiService.get(routes.serviceTypes(id)).pipe();
  }

  /**
   * Get ParentId list
   */
  getParentIds(code: any) {
    return this.apiService.get(routes.parentIds(code)).pipe();
  }

  /**
   * sign
   */
  signDocument(id: string) {
    return null;
    /* return this.apiService.post(routes.sign(id)); */
  }

  /**
   * Get document type by id
   */
  getDocumentTypeById(id: string) {
    return this.apiService.get(routes.getDocumentTypeById(id)).pipe();
  }

  // Get document refer by id
  getDocumentReferById(id: string) {
    return this.apiService.get(routes.getDocumentReferById(id)).pipe();
  }

  // silent: man view-document tu quan ly loading rieng, khong block UI toan trang
  getDocumentReferByIdSilently(id: string) {
    return this.apiService.getSilently(routes.getDocumentReferById(id)).pipe();
  }

  /**
   * Get document by id
   */
  getDocumentById(id: string) {
    return this.apiService.get(routes.document(id))
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Get document by id (silent): man add-document tu quan ly loading, khong block UI toan trang
   */
  getDocumentByIdSilently(id: string) {
    return this.apiService.getSilently(routes.document(id))
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Get signers
   */
  getSigners(id) {
    return this.apiService.get(routes.signers(id));
  }

  /**
   * Save Submission
   */
  saveSubmission(submission: any) {
    return this.apiService.post('/contract/submit', submission);
  }

  /**
   * Create new document
   */
  createDocumentByTemplate(documentData: any, errCallback: any): Observable<any> {
    return this.handleErrCallback(documentData, errCallback, routes.createDocumentByTemplate());
  }

  /**
   * Update new document
   */
  updateDocumentByTemplate(documentData: any, errCallback: any) {
    return this.handleErrCallback(documentData, errCallback, routes.updateDocumentByTemplate());
  }

  // Get teamplate for document type
  getHtmlOfDocumentSystem(id: string) {
    return this.apiService.get(`/file/viewDocTypeHtml/${id}`)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Download pdf
   */
  downloadPdf(id: string) {
    return this.apiService.getFile(routes.viewContractPdf(id))
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Update status of document -> reject
   */
  reject(document: any) {
    return this.apiService.post('/contract/reject', document)
      .pipe(map(res => {
        return res;
      }));
  }

  rejectDirectly(document: any) {
    return this.apiService.post(routes.rejectDirectly, document)
      .pipe(map(res => {
        return res;
      }));
  }

  cancelSignFlow(document: any) {
    return this.apiService.post(routes.cancelSignFlow, document)
      .pipe(map(res => {
        return res;
      }));
  }

  approvalDocument(document: any) {
    return this.apiService.post(routes.approvalDocument, document)
      .pipe(map(res => {
        return res;
      }));
  }


  approvalDocumentDigital(document: any) {
    return this.apiService.post(routes.approvalDocument, document)
      .pipe(map(res => {
        return res;
      }));
  }


  declineApproveDocument(document: any) {
    return this.apiService.post(routes.declinedApproveDocument, document)
      .pipe(map(res => {
        return res;
      }));
  }

  declineSignDocument(document: any) {
    return this.apiService.post(routes.declinedSignDocument, document)
      .pipe(map(res => {
        return res;
      }));
  }

  declineConfirmDocument(document: any) {
    return this.apiService.post(routes.declinedConfirmDocument, document)
      .pipe(map(res => {
        return res;
      }));
  }

  acceptConfirmDocument(document: any) {
    return this.apiService.post(routes.acceptConfirmDocument, document)
      .pipe(map(res => {
        return res;
      }));
  }

  moneyTransfer(money: any) {
    return this.apiService.post(routes.moneyTransfer(money))
      .pipe(map(res => {
        return res;
      }));
  }

  validateSignaturePprocess(listID: any) {
    return this.apiService.post(routes.validateSignaturePprocess,listID)
      .pipe(map(res => {
        return res;
      }));
  }

  moneyTransferCts(money: any) {
    return this.apiService.post(routes.moneyTransferCts(money))
      .pipe(map(res => {
        return res;
      }));
  }

  initialSignDocument(document: any) {
    return this.apiService.post(routes.initialSignDocument, document)
      .pipe(map(res => {
        return res;
      }));
  }

  declineInitialSignDocument(document: any) {
    return this.apiService.post(routes.declineInitialSignDocument, document)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Send contract
   */
  sendContract(id: any) {
    return this.apiService.get(routes.sendContract(id))
      .pipe(map(res => {
        return res;
      }));
  }

  sendStartSignFlow(id: any) {
    return this.apiService.get(routes.startSignFlow(id))
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Compare Serianumber and create Hash
   */
  createHash(hash: any) {
    return this.apiService.post(routes.createHash(), hash)
      .pipe(map(res => {
        return res;
      }));
  }

  createHashNoImage(hash: any, signLot ?: boolean) {
    return this.apiService.post(routes.createHashNoImage(signLot), hash)
      .pipe(map(res => {
        return res;
      }));
  }

  createMultiHashNoImage(hash: any, signLot ?: boolean) {
    return this.apiService.post(routes.createMultiHashNoImage(signLot), hash)
      .pipe(map(res => {
        return res;
      }));
  }

  createMultiApproveHashNoImage(hash: any, signLot ?: boolean) {
    return this.apiService.post(routes.createMultiApproveHashNoImage(signLot), hash)
      .pipe(map(res => {
        return res;
      }));
  }

  createMultiApproveAppendNoCert(data) {
    return this.apiService.post(routes.createMultiApproveAppendNoCert(), data)
      .pipe(map(res => {
        return res;
      }));
  }

  createMultiHashImage(hash: any, signLot ?: boolean) {
    return this.apiService.post(routes.createMultiHashImage(signLot), hash)
      .pipe(map(res => {
        return res;
      }));
  }

  createMultiApproveHashImage(hash: any, signLot ?: boolean) {
    return this.apiService.post(routes.createMultiApproveHashImage(signLot), hash)
      .pipe(map(res => {
        return res;
      }));
  }


  cancelSignBatch() {
    return this.apiService.post(routes.cancelSignBatch())
      .pipe(map(res => {
        return res;
      }));
  }

  cancelSignBatchDigital() {
    return this.apiService.post(routes.cancelSignBatchDigital())
      .pipe(map(res => {
        return res;
      }));
  }

  cancelApproveBatch() {
    return this.apiService.post(routes.cancelApproveBatch())
      .pipe(map(res => {
        return res;
      }));
  }

  createHashWithImage(hash: any, signLot?: boolean) {
    return this.apiService.postJson(routes.createHashWithImage(signLot), hash)
      .pipe(map(res => res));
  }

  createHashWithImageMoha(hash: any, signLot?: boolean) {
    return this.apiService.postFormData(routes.createHashWithImageMoha(signLot), hash)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Version Base64 cua createHashWithImage - anh chu ky gui JSON thay multipart binary.
   */
  createHashWithImageBase64 = async (hash: any, signLot?: boolean) => {
    const body = {...hash};
    if (body.image instanceof Blob) {
      body.image = await this.commonService.getFileBase64(body.image as File);
    }
    // multipart cũ tự stringify array (signPositions/position) - JSON phai convert tay de BE nhan String
    if (body.signPositions && typeof body.signPositions !== 'string') {
      body.signPositions = JSON.stringify(body.signPositions);
    }
    if (body.position && typeof body.position !== 'string') {
      body.position = JSON.stringify(body.position);
    }
    return this.apiService.postFileBase64(routes.createHashWithImage(signLot), body)
      .pipe(map(res => {
        return res;
      })).toPromise();
  }


  createHashDirectly(hash: any) {
    return this.apiService.post(routes.createHashDirectly(), hash)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Compare Serianumber and create Hash
   */
  signUsb(certificate: any, signLot ?: boolean) {
    return this.apiService.post(routes.signUsb(signLot), certificate)
      .pipe(map(res => {
        return res;
      }));
  }
  /**
   * Compare Serianumber and create Hash moha
   */
  signUsbMoha(certificate: any, signLot ?: boolean) {
    return this.apiService.post(routes.signUsbMoha(signLot), certificate)
      .pipe(map(res => {
        return res;
      }));
  }

  signUsbDigital(certificate: any, signLot ?: boolean) {
    return this.apiService.post(routes.signUsbDigital, certificate)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Compare Serianumber and create Hash
   */
  signBatchUsb(certificate: any, signLot ?: boolean) {
    return this.apiService.post(routes.signBatchUsb(signLot), certificate)
      .pipe(map(res => {
        return res;
      }));
  }

  approveBatchUsb(certificate: any, signLot ?: boolean) {
    return this.apiService.post(routes.approveBatchUsb(signLot), certificate)
      .pipe(map(res => {
        return res;
      }));
  }

  signUsbDirectly(certificate: any) {
    return this.apiService.post(routes.signUsbDirectly(), certificate)
      .pipe(map(res => {
        return res;
      }));
  }


  searchDocumentContractCompany(filter: any) {
    return this.apiService.postSilently(routes.filterContractCompany, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }


  filterStandardizedContracts(filter: any) {
    return this.apiService.postSilently(routes.filterContractStandardized, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }


  filterStandardizedContractsExecute(filter: any) {
    return this.apiService.post(routes.filterContractStandardizedExecute, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  addStandardizedContracts(body: any) {
    return this.apiService.post(routes.addContractStandardized, body).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  getStandardizedNotes(id: string) {
    return this.apiService.get(routes.standardizedNotes(id)).pipe(
      map(rs => {
        return rs;
      })
    );
  }


  /**
   * get sign all document
   * @param filter searching filter of document sign waiting.
   */
  public getDocumentsBySignAll(filter) {
    return this.apiService.post(routes.getDocumentBySignAll(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  public getDocumentsByApproveAll(filter) {
    return this.apiService.post(routes.getDocumentByApproveAll(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  public getDigitalDocumentsBySignAll(filter) {
    return this.apiService.post(routes.getDigitalDocumentsBySignAll(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * request sign list of documents or sign all.
   * @param slotIds list of document id.
   */
  public submitSignedDocuments(slotIds, image = null) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;
    return this.apiService.post(routes.submitSignedDocuments(), {
      slotIds,
      base64Image: image
    })
      .pipe(map(res => {
        return res;
      }));
  }

  public submitApproveDocumentsWithoutCertificate(slotIds, message) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;
    return this.apiService.post(routes.submitApprovedDocumentsWithoutCertificate(), {
      slotIds,
      message
    })
      .pipe(map(res => {
        return res;
      }));
  }

  public submitDeclineDocuments(slotIds, message) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;
    return this.apiService.post(routes.submitDeclineDocuments(), {
      slotIds,
      message
    })
      .pipe(map(res => {
        return res;
      }));
  }

  public submitSignMultiCloudCa(slotIds, detailId, image,type?) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;
if(type){
  const payload = {
    contractIds: slotIds,
    digitalCertificateDetailId: detailId,
    base64Image: image,
    type:4
  };
  return this.apiService.post(routes.submitSignMultiCloudCa(), payload)
    .pipe(map(res => {
      return res;
    }));
}else{
  const payload = {
    contractIds: slotIds,
    digitalCertificateDetailId: detailId,
    base64Image: image
  };
  return this.apiService.post(routes.submitSignMultiCloudCa(), payload)
    .pipe(map(res => {
      return res;
    }));
}

  }

  public submitSignMultiSessionCloudCa(slotIds, detailId, image,type?) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;
    if(type){
      const payload = {
        contractIds: slotIds,
        digitalCertificateDetailId: detailId,
        base64Image: image,
        type:4
      };
      return this.apiService.post(routes.submitSignMultiSessionCloudCa(), payload)
        .pipe(map(res => {
          return res;
        }));
    }else{
      const payload = {
        contractIds: slotIds,
        digitalCertificateDetailId: detailId,
        base64Image: image
      };
      return this.apiService.post(routes.submitSignMultiSessionCloudCa(), payload)
        .pipe(map(res => {
          return res;
        }));
    }
  }

  public submitSignDigitalMultiCloudCa(slotIds, detailId, image,type?) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;

    const payload = {
      contractIds: slotIds,
      digitalCertificateDetailId: detailId,
      base64Image: image
    };
    return this.apiService.post(routes.submitSignDigitalMultiCloudCa(), payload)
      .pipe(map(res => {
        return res;
    }));

  }

  public submitApproveMultiCloudCa(slotIds, detailId, image) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;

    const payload = {
      contractIds: slotIds,
      digitalCertificateDetailId: detailId,
      base64Image: image
    };
    return this.apiService.post(routes.submitApproveMultiCloudCa(), payload)
      .pipe(map(res => {
        return res;
      }));
  }

  public submitApproveMultiSessionCloudCa(slotIds, detailId, image) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;

    const payload = {
      contractIds: slotIds,
      digitalCertificateDetailId: detailId,
      base64Image: image
    };
    return this.apiService.post(routes.submitApproveMultiSessionCloudCa(), payload)
      .pipe(map(res => {
        return res;
      }));
  }


  public usbTokenInitSignGroup(payload) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;
    return this.apiService.post(routes.usbTokenInitSignGroup(), payload)
      .pipe(map(res => {
        return res;
      }));
  }

  public usbTokenInitApproveGroup(payload) {
    // update flag to false in order to sign.
    this.isStopSignSlot = false;
    this.percent = 0;
    return this.apiService.post(routes.usbTokenInitApproveGroup(), payload)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Get slot status.
   * Format of returned result.
   * {
   *    "details": {
   *      "id": "string",
   *      "createdTime": "DATE",
   *      "cancelTime": "",
   *      "description": "",
   *      "success": false,
   *      "details": [
   *        {
   *          "contractId": "",
   *          "status": 0,
   *          "description": ""
   *        }
   *      ]
   *    },
   *    "contracts": "json array of contracts"
   * }
   */
  public getSlotStatus(hasPreviousData, isFinished = false) {
    // initialize request timer.
    // register event of calling.
    if (this.slotRequestTimer != null) {
      return;
    }

    let signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
    this.slotRequestTimer = timer(100, DocumentService.CALL_INTERVAL).subscribe(t => {
      if (this.isReadyToCalling) {
        this.isReadyToCalling = false;
        this.apiService.get(routes.getSignSlotStatus(hasPreviousData))
          .pipe(map(res => {
            return res;
          })).subscribe((res) => {
          // console.log("timer res: " + JSON.stringify(res));
          if (!res || !res.data) {
            this.unRegisterSignSlotTimer();
            signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
          } else {

            if (res.data === 'expired') {
              this.toastr.error(this.message.getMessage('messages.sign_batch_expired'));
              this.unRegisterSignSlotTimer();
              const tmp = this.resTmp.data.info.details.map(ct => {
                if (ct.status === DocumentService.STATUS_WAIT) {
                  ct.status = DocumentService.STATUS_FAIL;
                  // signedCount++;
                }
                return ct;
              });

              this.resTmp.data.info.details = tmp;
              console.log('thay doi resTmp: ' + JSON.stringify(this.resTmp));

              this.signUpdateAction.next({
                res: this.resTmp,
                percent: 100,
                signStatus: DocumentService.SLOT_SIGN_STOP,
                isStopSignSlot: false,
                expired: true,
              });

              this.isReadyToCalling = true;
              return;
            }
            let signedCount = 0;
            let signDoneCount = 0;
            let signDaemonCount = 0;
            const totalDocument = res.data.info.details.length;

            // update status for each document.
            res.data.info.details.forEach(ct => {
              if (ct.status === DocumentService.STATUS_DONE
                || ct.status === DocumentService.STATUS_FAIL
                ) {
                signedCount++;
                if (ct.status === DocumentService.STATUS_DONE) {
                  signDoneCount++;
                }
                if (ct.status === DocumentService.STATUS_DAEMON) {
                  signDaemonCount++;
                }
              }
            });

            this.percent = Number((signedCount / totalDocument * 100).toFixed(0));

            if (signedCount === totalDocument && signDaemonCount == 0) {
              if (signDoneCount == 0 && signDaemonCount == 0) {
                !isFinished && this.toastr.error(this.message.getMessage('messages.sign_finish_fail'));
              } else {
                !isFinished && this.toastr.success(this.commonService.format(this.message.getMessage('messages.sign_finish'), signDoneCount + signDaemonCount, totalDocument));
              }
              signStatus = DocumentService.SLOT_SIGN_FINISH;
              this.unRegisterSignSlotTimer();
            } else {
              if (this.isStopSignSlot) {
                signStatus = DocumentService.SLOT_SIGN_STOP;
                this.unRegisterSignSlotTimer();
              } else {
                signStatus = DocumentService.SLOT_SIGN_PROCESSING;
              }
            }
          }
          if (res && res.data && res.data.info && res.data.info.details) {
            this.resTmp = res;
          }
          this.signUpdateAction.next({
            res,
            percent: this.percent,
            signStatus,
            isStopSignSlot: this.isStopSignSlot
          });

          this.isReadyToCalling = true;
        });
      }
    });
  }

  public getWaitSlotStatus(hasPreviousData, isFinished = false) {
    // initialize request timer.
    // register event of calling.
    if (this.slotRequestTimer != null) {
      return;
    }

    let signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
    this.slotRequestTimer = timer(100, DocumentService.CALL_INTERVAL).subscribe(t => {
      if (this.isReadyToCalling) {
        this.isReadyToCalling = false;
        this.apiService.get(routes.getSignWaitSlotStatus(hasPreviousData))
          .pipe(map(res => {
            return res;
          })).subscribe((res) => {
          // console.log("timer res: " + JSON.stringify(res));
          if (!res || !res.data) {
            this.unRegisterSignSlotTimer();
            signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
          } else {

            if (res.data === 'expired') {
              this.toastr.error(this.message.getMessage('messages.sign_batch_expired'));
              this.unRegisterSignSlotTimer();
              const tmp = this.resTmp.data.info.details.map(ct => {
                if (ct.status === DocumentService.STATUS_WAIT) {
                  ct.status = DocumentService.STATUS_FAIL;
                  // signedCount++;
                }
                return ct;
              });

              this.resTmp.data.info.details = tmp;
              console.log('thay doi resTmp: ' + JSON.stringify(this.resTmp));

              this.signWaitUpdateAction.next({
                res: this.resTmp,
                percent: 100,
                signStatus: DocumentService.SLOT_SIGN_STOP,
                isStopSignSlot: false,
                expired: true,
              });

              this.isReadyToCalling = true;
              return;
            }
            let signedCount = 0;
            let signDoneCount = 0;
            let signDaemonCount = 0;
            const totalDocument = res.data.info.details.length;

            // update status for each document.
            res.data.info.details.forEach(ct => {
              if (ct.status === DocumentService.STATUS_DONE
                || ct.status === DocumentService.STATUS_FAIL
                ) {
                signedCount++;
                if (ct.status === DocumentService.STATUS_DONE) {
                  signDoneCount++;
                }
                if (ct.status === DocumentService.STATUS_DAEMON) {
                  signDaemonCount++;
                }
              }
            });

            this.percent = Number((signedCount / totalDocument * 100).toFixed(0));

            if (signedCount === totalDocument && signDaemonCount == 0) {
              if (signDoneCount == 0 && signDaemonCount == 0) {
                !isFinished && this.toastr.error(this.message.getMessage('messages.sign_wait_finish_fail'));
              } else {
                !isFinished && this.toastr.success(this.commonService.format(this.message.getMessage('messages.sign_wait_finish'), signDoneCount + signDaemonCount, totalDocument));
              }
              signStatus = DocumentService.SLOT_SIGN_FINISH;
              this.unRegisterSignSlotTimer();
            } else {
              if (this.isStopSignSlot) {
                signStatus = DocumentService.SLOT_SIGN_STOP;
                this.unRegisterSignSlotTimer();
              } else {
                signStatus = DocumentService.SLOT_SIGN_PROCESSING;
              }
            }
          }
          if (res && res.data && res.data.info && res.data.info.details) {
            this.resTmp = res;
          }
          this.signWaitUpdateAction.next({
            res,
            percent: this.percent,
            signStatus,
            isStopSignSlot: this.isStopSignSlot
          });

          this.isReadyToCalling = true;
        });
      }
    });
  }

  public getApproveSlotStatus(hasPreviousData, isFinished = false) {
    // initialize request timer.
    // register event of calling.
    if (this.slotRequestTimer != null) {
      return;
    }

    let signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
    this.slotRequestTimer = timer(100, DocumentService.CALL_INTERVAL).subscribe(t => {
      if (this.isReadyToCalling) {
        this.isReadyToCalling = false;
        this.apiService.get(routes.getApproveSlotStatus(hasPreviousData))
          .pipe(map(res => {
            return res;
          })).subscribe((res) => {
          // console.log("timer res: " + JSON.stringify(res));
          if (!res || !res.data) {
            this.unRegisterSignSlotTimer();
            signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
          } else {

            if (res.data === 'expired') {
              this.toastr.error(this.message.getMessage('messages.approve_batch_expired'));
              this.unRegisterSignSlotTimer();
              const tmp = this.resTmp.data.info.details.map(ct => {
                if (ct.status === DocumentService.STATUS_WAIT) {
                  ct.status = DocumentService.STATUS_FAIL;
                  // signedCount++;
                }
                return ct;
              });

              this.resTmp.data.info.details = tmp;
              console.log('thay doi resTmp: ' + JSON.stringify(this.resTmp));

              this.approveUpdateAction.next({
                res: this.resTmp,
                percent: 100,
                signStatus: DocumentService.SLOT_SIGN_STOP,
                isStopSignSlot: false,
                expired: true,
              });

              this.isReadyToCalling = true;
              return;
            }
            let signedCount = 0;
            let signDoneCount = 0;
            let signDaemonCount = 0;
            const totalDocument = res.data.info.details.length;

            // update status for each document.
            res.data.info.details.forEach(ct => {
              if (ct.status === DocumentService.STATUS_DONE
                || ct.status === DocumentService.STATUS_FAIL
                ) {
                signedCount++;
                if (ct.status === DocumentService.STATUS_DONE) {
                  signDoneCount++;
                }
                if (ct.status === DocumentService.STATUS_DAEMON) {
                  signDaemonCount++;
                }
              }
            });

            this.percent = Number((signedCount / totalDocument * 100).toFixed(0));

            if (signedCount === totalDocument && signDaemonCount == 0) {
              if (signDoneCount == 0 && signDaemonCount == 0) {
                !isFinished && this.toastr.error(this.message.getMessage('messages.approve_finish_fail'));
              } else {
                !isFinished && this.toastr.success(this.commonService.format(this.message.getMessage('messages.approve_finish'), signDoneCount + signDaemonCount, totalDocument));
              }
              signStatus = DocumentService.SLOT_SIGN_FINISH;
              this.unRegisterSignSlotTimer();
            } else {
              if (this.isStopSignSlot) {
                signStatus = DocumentService.SLOT_SIGN_STOP;
                this.unRegisterSignSlotTimer();
              } else {
                signStatus = DocumentService.SLOT_SIGN_PROCESSING;
              }
            }
          }
          if (res && res.data && res.data.info && res.data.info.details) {
            this.resTmp = res;
          }
          this.approveUpdateAction.next({
            res,
            percent: this.percent,
            signStatus,
            isStopSignSlot: this.isStopSignSlot
          });
          this.isReadyToCalling = true;
        });
      }
    });
  }

  public getDeclineApprovalSlotStatus(hasPreviousData, isFinished = false) {
    // initialize request timer.
    // register event of calling.
    if (this.slotRequestTimer != null) {
      return;
    }

    let signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
    this.slotRequestTimer = timer(100, DocumentService.CALL_INTERVAL).subscribe(t => {
      if (this.isReadyToCalling) {
        this.isReadyToCalling = false;
        this.apiService.get(routes.getDeclineApprovalSlotStatus(hasPreviousData))
          .pipe(map(res => {
            return res;
          })).subscribe((res) => {
          // console.log("timer res: " + JSON.stringify(res));
          if (!res || !res.data) {
            this.unRegisterSignSlotTimer();
            signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
          } else {

            if (res.data === 'expired') {
              this.toastr.error(this.message.getMessage('messages.decline_approval_batch_expired'));
              this.unRegisterSignSlotTimer();
              const tmp = this.resTmp.data.info.details.map(ct => {
                if (ct.status === DocumentService.STATUS_WAIT) {
                  ct.status = DocumentService.STATUS_FAIL;
                  // signedCount++;
                }
                return ct;
              });

              this.resTmp.data.info.details = tmp;
              console.log('thay doi resTmp: ' + JSON.stringify(this.resTmp));

              this.declineUpdateAction.next({
                res: this.resTmp,
                percent: 100,
                signStatus: DocumentService.SLOT_SIGN_STOP,
                isStopSignSlot: false,
                expired: true,
              });

              this.isReadyToCalling = true;
              return;
            }
            let signedCount = 0;
            let signDoneCount = 0;
            const totalDocument = res.data.info.details.length;

            // update status for each document.
            res.data.info.details.forEach(ct => {
              if (ct.status === DocumentService.STATUS_DONE
                || ct.status === DocumentService.STATUS_FAIL) {
                signedCount++;
                if (ct.status === DocumentService.STATUS_DONE) {
                  signDoneCount++;
                }
              }
            });

            this.percent = Number((signedCount / totalDocument * 100).toFixed(0));

            if (signedCount === totalDocument) {
              if (signDoneCount == 0) {
                !isFinished && this.toastr.error(this.message.getMessage('messages.decline_approval_finish_fail'));
              } else {
                !isFinished && this.toastr.success(this.commonService.format(this.message.getMessage('messages.decline_approval_finish'), signDoneCount, totalDocument));
              }
              signStatus = DocumentService.SLOT_SIGN_FINISH;
              this.unRegisterSignSlotTimer();
            } else {
              if (this.isStopSignSlot) {
                signStatus = DocumentService.SLOT_SIGN_STOP;
                this.unRegisterSignSlotTimer();
              } else {
                signStatus = DocumentService.SLOT_SIGN_PROCESSING;
              }
            }
          }
          if (res && res.data && res.data.info && res.data.info.details) {
            this.resTmp = res;
          }
          this.declineUpdateAction.next({
            res,
            percent: this.percent,
            signStatus,
            isStopSignSlot: this.isStopSignSlot
          });

          this.isReadyToCalling = true;
        });
      }
    });
  }

  public getDigitalSlotStatus(hasPreviousData, isFinished = false) {
    // initialize request timer.
    // register event of calling.
    if (this.slotRequestTimer != null) {
      return;
    }

    let signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
    this.slotRequestTimer = timer(100, DocumentService.CALL_INTERVAL).subscribe(t => {
      if (this.isReadyToCalling) {
        this.isReadyToCalling = false;
        this.apiService.get(routes.getDigitalSlotStatus(hasPreviousData))
          .pipe(map(res => {
            return res;
          })).subscribe((res) => {
          // console.log("timer res: " + JSON.stringify(res));
          if (!res || !res.data) {
            this.unRegisterSignSlotTimer();
            signStatus = DocumentService.SLOT_SIGN_NO_ACTION;
          } else {

            if (res.data === 'expired') {
              this.toastr.error(this.message.getMessage('messages.sign_batch_expired'));
              this.unRegisterSignSlotTimer();
              const tmp = this.resTmp.data.info.details.map(ct => {
                if (ct.status === DocumentService.STATUS_WAIT) {
                  ct.status = DocumentService.STATUS_FAIL;
                  // signedCount++;
                }
                return ct;
              });

              this.resTmp.data.info.details = tmp;
              console.log('thay doi resTmp: ' + JSON.stringify(this.resTmp));

              this.signDigitalUpdateAction.next({
                res: this.resTmp,
                percent: 100,
                signStatus: DocumentService.SLOT_SIGN_STOP,
                isStopSignSlot: false,
                expired: true,
              });

              this.isReadyToCalling = true;
              return;
            }
            let signedCount = 0;
            let signDoneCount = 0;
            let signDaemonCount = 0;
            const totalDocument = res.data.info.details.length;

            // update status for each document.
            res.data.info.details.forEach(ct => {
              if (ct.status === DocumentService.STATUS_DONE
                || ct.status === DocumentService.STATUS_FAIL
                || ct.status === DocumentService.STATUS_DAEMON) {
                signedCount++;
                if (ct.status === DocumentService.STATUS_DONE) {
                  signDoneCount++;
                }
                if (ct.status === DocumentService.STATUS_DAEMON) {
                  signDaemonCount++;
                }
              }
            });

            this.percent = Number((signedCount / totalDocument * 100).toFixed(0));

            if (signedCount === totalDocument && signDaemonCount == 0) {
              if (signDoneCount == 0 && signDaemonCount == 0) {
                !isFinished && this.toastr.error(this.message.getMessage('messages.sign_finish_fail'));
              } else {
                !isFinished && this.toastr.success(this.commonService.format(this.message.getMessage('messages.sign_finish'), signDoneCount + signDaemonCount, totalDocument));
              }
              signStatus = DocumentService.SLOT_SIGN_FINISH;
              this.unRegisterSignSlotTimer();
            } else {
              if (this.isStopSignSlot) {
                signStatus = DocumentService.SLOT_SIGN_STOP;
                this.unRegisterSignSlotTimer();
              } else {
                signStatus = DocumentService.SLOT_SIGN_PROCESSING;
              }
            }
          }
          if (res && res.data && res.data.info && res.data.info.details) {
            this.resTmp = res;
          }
          this.signDigitalUpdateAction.next({
            res,
            percent: this.percent,
            signStatus,
            isStopSignSlot: this.isStopSignSlot
          });

          this.isReadyToCalling = true;
        });
      }
    });
  }

  /**
   * Call stop signing to server.
   */
  public stopSign() {
    return this.apiService.get(routes.stopSign())
      .pipe(map(res => {
        if (res && res.data) {
          this.toastr.success(this.message.getMessage('messages.sign_stop_success'));
        }
        this.isStopSignSlot = true;
        this.signUpdateAction.next({
          res,
          percent: this.percent,
          signStatus: DocumentService.SLOT_SIGN_STOP,
          isStopSignSlot: true
        });

        return res;
      }));
  }


  public stopSignWait(){
    return this.apiService.get(routes.stopSignWait())
      .pipe(map(res => {
        if (res && res.data) {
          this.toastr.success(this.message.getMessage('messages.sign_wait_stop_success'));
        }
        this.isStopSignSlot = true;
        this.signWaitUpdateAction.next({
          res,
          percent: this.percent,
          signStatus: DocumentService.SLOT_SIGN_STOP,
          isStopSignSlot: true
        });

        return res;
      }));
  }
  public stopApprove() {
    return this.apiService.get(routes.stopApprove())
      .pipe(map(res => {
        if (res && res.data) {
          this.toastr.success(this.message.getMessage('messages.approve_stop_success'));
        }
        this.isStopSignSlot = true;
        this.approveUpdateAction.next({
          res,
          percent: this.percent,
          signStatus: DocumentService.SLOT_SIGN_STOP,
          isStopSignSlot: true
        });

        return res;
      }));
  }

  public stopDecline() {
    return this.apiService.get(routes.stopDecline())
      .pipe(map(res => {
        if (res && res.data) {
          this.toastr.success(this.message.getMessage('messages.decline_stop_success'));
        }
        this.isStopSignSlot = true;
        this.declineUpdateAction.next({
          res,
          percent: this.percent,
          signStatus: DocumentService.SLOT_SIGN_STOP,
          isStopSignSlot: true
        });

        return res;
      }));
  }

  public stopSignDigital() {
    return this.apiService.get(routes.stopSignDigital())
      .pipe(map(res => {
        if (res && res.data) {
          this.toastr.success(this.message.getMessage('messages.sign_stop_success'));
        }
        this.isStopSignSlot = true;
        this.signUpdateAction.next({
          res,
          percent: this.percent,
          signStatus: DocumentService.SLOT_SIGN_STOP,
          isStopSignSlot: true
        });

        return res;
      }));
  }

  /**
   * clear all resource after log out.
   */
  public clearResource() {
    this.unRegisterSignSlotTimer();
  }

  /**
   * Un register sign slot timer.
   */
  private unRegisterSignSlotTimer() {
    if (this.slotRequestTimer) {
      this.slotRequestTimer.unsubscribe();
      this.slotRequestTimer = null;
    }
  }

  /**
   * upload multi file attach for document with formdata
   */
  uploadMultiFileAttachForDocument(listFile: any) {
    const formdata = new FormData();
    for (let index = 0; index < listFile.length; index++) {
      formdata.append('file', listFile[index]);
    }

    return this.apiService.postUpload(routes.uploadMultiFileAttachForDocument(), formdata)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Check if template is locked or not
   */
  public checkTemplate(templateId: string) {
    return this.apiService.get(routes.checkTemplate(templateId));
  }

  /**
   * Handle callback
   * @param document Obj document input
   * @param errCallback callback error
   * @param apiLink respone api return
   */
  handleErrCallback(document: any, errCallback: any, apiLink: string): Observable<any> {
    return this.apiService.post(apiLink, document)
      .pipe(map(res => {
        if (errCallback && !res.success) {
          errCallback(res);
        }

        return res;
      }));
  }

  getDocumentsType(isDocumentMoha: boolean = false) {
    if(!isDocumentMoha){
      return this.apiService.get('/enterprise/document-type/all?isEmploymentContract=false').pipe();
    }else{
      return this.apiService.get('/enterprise/document-type/all?isEmploymentContract=true').pipe();
    }
    let body = {
      nameOrCode: null,
      serviceType: null,
      status: null,
      isDraft: null,
      isEmploymentContract: true,
      isCreate: false,
      page: 0,
      size: 1000
    }
    return this.apiService.post(`/dc/document-type-enterprises/get-all`, body).pipe(map(res => {
      if(res.data){
        return {
          data: res.data.content! || []
        }
      }
      return res;
    }));
  }

  // Get list enterprise user sign
  getListEnterpriseUserSignBydocumentIdService(documentId: any) {
    return this.apiService.get(routes.getListEnterpriseUserSign(documentId))
      .pipe(map(res => {
        return res;
      }));
  }

  // silent: man add-document tu quan ly loading, khong block UI toan trang
  getListEnterpriseUserSignBydocumentIdSilently(documentId: any) {
    return this.apiService.getSilently(routes.getListEnterpriseUserSign(documentId))
      .pipe(map(res => {
        return res;
      }));
  }

  // Get list enterprise user sign for copy function
  getListEnterpriseUserSignForCopy(documentId: any) {
    return this.apiService.get(routes.getListEnterpriseUserSignForCopy(documentId))
      .pipe(map(res => {
        return res;
      }));
  }

  // silent: flow copy tai add-document, khong block UI toan trang
  getListEnterpriseUserSignForCopySilently(documentId: any) {
    return this.apiService.getSilently(routes.getListEnterpriseUserSignForCopy(documentId))
      .pipe(map(res => {
        return res;
      }));
  }

  getListEnterpriseUserSignByTemplateId(templateId: any) {
    return this.apiService.get(routes.getListEnterpriseUserSignByTemplateId(templateId))
      .pipe(map(res => {
        return res;
      }));
  }

  // silent: chon mau tai add-document, khong block UI toan trang
  getListEnterpriseUserSignByTemplateIdSilently(templateId: any) {
    return this.apiService.getSilently(routes.getListEnterpriseUserSignByTemplateId(templateId))
      .pipe(map(res => {
        return res;
      }));
  }

  // Get file output
  previewOutputFile(url: string): Observable<File> {
    return this.apiService.getFilePostMethod(routes.previewOutputFile, {url});
  }

  setContractInfo(contract: any) {
    this.contractSource.next(contract);
  }

  setCancelFlow(status: boolean) {
    this.cancelFlowSource.next(status);
  }

  setContractFileInfo(filesInfo: any) {
    this.contractFilesSource.next(filesInfo);
  }

  getAllUserProcessById(documentId: string) {
    return this.apiService.get(routes.getUserProcessByContractId(documentId))
      .pipe(map(res => {
        return res;
      }));
  }

  sendUserSignContract(documentId: string, data: any) {
    return this.apiService.post(routes.sendUserSignContractByContractId(documentId), data)
      .pipe(map(res => {
        return res;
      }));
  }

  retrieveSignLink(documentId: string, data: any) {
    return this.apiService.post(routes.retrieveSignLink(documentId), data)
    .pipe(map(res => {
      return res;
    }));
  }

  downloadFileZip(id: string) {
    return this.apiService.getFilePostMethod(`/file/download/contract-files-zip/${id}`, {}).pipe(
      map(res => {
        return res;
      })
    );
  }

  preDownloadMultiFileZip(data: { menuContract?: string, contractIds?: string[], isDigital?: boolean }): Observable<any> {
    const {isDigital, ...body} = data;
    return this.apiService.post(!isDigital ? routes.preMultiDownload : routes.preMultiDownloadDigital, body);
  }


  downloadMultiFileZip(key: string, isDigital?: boolean) {
    if (key && typeof key === 'string') {
      const currentUser = localStorage.getItem('token') || sessionStorage.getItem('token');
      const lang = localStorage.getItem('__language') || 'vi';
      this.apiService.actionDownloadFile(!isDigital ? routes.multiDownload(key, currentUser, lang) : routes.multiDownloadDigital(key, currentUser, lang));
    }
  }

  downloadFileCertificate(id: string) {
    return this.apiService.getFile(routes.fileSignAdminDownload(id)).pipe(
      map(res => {
        return res;
      })
    );
  }

  /**
   * Search list personal receive contract
   */
  searchMyReceiveContract(filter: any) {
    return this.apiService.postSilently(routes.filterReceiveMine, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  searchProcessingDocument(filter: any) {
    return this.apiService.postSilently(routes.searchProcessingDocument, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  searchNegotiateContract(filter: any) {
    return this.apiService.postSilently(routes.searchNegotiateDocument, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Forward contract share
   */
  forwardContract(body: object) {
    return this.apiService.post(routes.forwardContract, body).pipe(
      map(res => {
        return res;
      })
    );
  }

  signatureProcessLotFlow(body) {
    return this.apiService.post(routes.signatureProcessLotFlow, body)
      .pipe(map(res => {
        return res;
      }));
  }

  deleteLotCancelFlow(body) {
    return this.apiService.post(routes.deleteLotCancelFlow, body)
      .pipe(map(res => {
        return res;
      }));
  }

  createSignContractFlow(body) {
    return this.apiService.post(routes.createSignContractFlow, body)
      .pipe(map(res => {
        return res;
      }));
  }

  signContractFlowInfo(id) {
    return this.apiService.get(routes.signContractFlowInfo(id))
      .pipe(map(res => {
        return res;
      }));
  }

  signGroupDetail(id: string) {
    return this.apiService.get(routes.signGroupDetail(id))
      .pipe(map(res => {
        return res;
      }));
  }

  checkProcessingContract(payload) {
    return this.apiService.post(routes.checkProcessingContract(), payload)
      .pipe(map(res => {
        return res;
      }));
  }

  checkProcessingApproveContract(payload) {
    return this.apiService.post(routes.checkProcessingApproveContract(), payload)
      .pipe(map(res => {
        return res;
      }));
  }

  signContractFlowProcessing(id) {
    return this.apiService.get(routes.signContractFlowProcessing(id))
      .pipe(map(res => {
        return res;
      }));
  }

  cancelContractFlow(id) {
    return this.apiService.get(routes.cancelContractFlow(id))
      .pipe(map(res => {
        return res;
      }));
  }

  signContractSignProcess(id) {
    return this.apiService.get(routes.signContractFlowProcessing(id))
      .pipe(map(res => {
        return res;
      }));
  }

  confirmContractFlow(id) {
    return this.apiService.get(routes.confirmContractFlow(id))
      .pipe(map(res => {
        return res;
      }));
  }

  signContractFlowCancel(id) {
    return this.apiService.get(routes.signContractFlowCancel(id))
      .pipe(map(res => {
        return res;
      }));
  }

  CancelContractFlowSignProcess(id) {
    return this.apiService.get(routes.CancelContractFlowSignProcess(id))
      .pipe(map(res => {
        return res;
      }));
  }

  CancelContractFlowCancel(id) {
    return this.apiService.get(routes.CancelContractFlowCancel(id))
      .pipe(map(res => {
        return res;
      }));
  }

  getSignContractFlowProcessingId() {
    return this.apiService.get(routes.getSignContractFlowId)
      .pipe(map(res => {
        return res;
      }));
  }

  retrySignFlow(body) {
    return this.apiService.post(routes.retrySignFlow, body)
      .pipe(map(res => {
        return res;
      }));
  }

  checkTimestampMoney(body) {
    return this.apiService.post(routes.checkTimestampMoney, body)
      .pipe(map(res => {
        return res;
      }));
  }

  createTimestampMoney(body) {
    return this.apiService.post(routes.createTimestampMoney, body)
      .pipe(map(res => {
        return res;
      }));
  }

  resetDown(body) {
    return this.apiService.post(routes.resetDown, body)
      .pipe(map(res => {
        return res;
      }));
  }

  resetAllDown(body) {
    return this.apiService.post(routes.resetAllDown, body)
      .pipe(map(res => {
        return res;
      }));
  }

  getTransactionDownById(body) {
    return this.apiService.post(routes.getDownById, body)
      .pipe(map(res => {
        return res;
      }));
  }

  getListDown(body) {
    return this.apiService.post(routes.getTransactionDown, body)
      .pipe(map(res => {
        return res;
      }));
  }

  autoGenerateContractCode(body) {
    return this.apiService.post(routes.autoGenerateContractCode, body)
      .pipe(map(res => {
        return res;
      }));
  }

  getSignImage(body) {
    return this.apiService.getFilePostMethod(routes.getSignImage, body)
      .pipe(map(res => {
        return res;
      }));
  }

  // Get list enterprise user sign
  getCustomerProcessing(contractId: any) {
    return this.apiService.get(routes.getCustomerProcessing(contractId))
      .pipe(map(res => {
        return res;
      }));
  }

  // Get contract user approve
  getContractUserApprove(contractId: any) {
    return this.apiService.get(routes.getContractUserApprove(contractId))
      .pipe(map(res => {
        return res;
      }));
  }

  // Gửi lại link HĐ
  reSendLinkUserSignContract(documentId: string, data: any) {
    return this.apiService.post(routes.reSendLinkUserSignContractByContractId(documentId), data)
      .pipe(map(res => {
        return res;
      }));
  }

  getDocWithWaterMark(id: string, fileName: string) {
    return this.apiService.getFilePostMethod(`/file/data-print-pdf/contract/${id}/${fileName}`, {}).pipe(
      map(res => {
        return res;
      })
    );
  }

  getDocWithWaterMarkV2(id: string, fileName: string) {
    return this.apiService.getFilePostMethod(`/file/data-for-print/contract-digital-files/${id}/${fileName}`, {}).pipe(
      map(res => {
        return res;
      })
    );
  }

  getDocWithWaterMarkAnonymous(id: string, hashKey: any, tenantId: any, contractIdAndContractEnterpriseIdEncode: any) {
    return this.apiService.getFilePostMethod(`/anonymous/pdf-for-print/${id}`, {
      hashKey,
      tenantId,
      contractIdAndContractEnterpriseIdEncode
    }).pipe(
      map(res => {
        return res;
      })
    );
  }

  getDocWithWaterMarkAnonymousV2(id: string, fileName: string, tenantId: string) {
    return this.apiService.getFilePostMethod(`/anonymous/data-print-pdf/contract/${id}/${fileName}/${tenantId}`, {}).pipe(
      map(res => {
        return res;
      })
    );
  }

  // Them nguoi phe duyet
  addApproverContractAnonymous(data) {
    return this.apiService.postWithToken(routes.addApproverContract, data)
      .pipe(map(res => {
        return res;
      }));
  }

  addApproverContract(data) {
    return this.apiService.post(routes.addApproverContract, data)
      .pipe(map(res => {
        return res;
      }));
  }
  saveColumnDynamic(data) {
    return this.apiService.post(routes.saveColumnDynamic, data)
      .pipe(map(res => {
        return res;
      }));
  }

  getColumnDynamic(idType: string) {
    return this.apiService.get(`/user-config/get-user-config/${idType}`).pipe(map(res => {
      return res;
    }));
  }

  getDeleteAllDraft() {
    return this.apiService.get(`/delete-all-draft/list-contract-draft`).pipe(map(res => {
      return res;
    }));
  }

  getSignAllDraft() {
    return this.apiService.get(`/sign-lot-flow/list-contract-draft`).pipe(map(res => {
      return res;
    }));
  }

  getThresholdContract(data: any){
    return this.apiService.post(`/common/app-param`, data).pipe(map(res => {
      return res;
    }));
  }

  createDeleteContractFlow(body) {
    return this.apiService.post(routes.createDeleteContractFlow, body)
      .pipe(map(res => {
        return res;
      }));
  }

  deleteContractFlowProcessing(id) {
    return this.apiService.get(routes.deleteContractFlowProcessing(id))
      .pipe(map(res => {
        return res;
      }));
  }

  deleteContractFlowCancel(id) {
    return this.apiService.get(routes.deleteContractFlowCancel(id))
      .pipe(map(res => {
        return res;
      }));
  }

  getDeleteContractFlowProcessingId() {
    return this.apiService.get(routes.getDeleteContractFlowId)
      .pipe(map(res => {
        return res;
      }));
  }

  undoOtpCustomer(customerId: string, contractId: string) {
    return this.apiService.post(routes.resetNumberOtp(customerId, contractId))
      .pipe(map(res => {
        return res;
      }));
  }

  saveContractWithNegotiate(contractId: string) {
    const body = {
      contractId: contractId
    }
    return this.apiService.post(routes.saveContractWithNegotiate, body)
      .pipe(map(res => {
        return res;
      }));
  }
  continueContractWithNegotiate(contractId: string) {
    const body = {
      contractId: contractId
    }
    return this.apiService.post(routes.continueContractWithNegotiate, body)
      .pipe(map(res => {
        return res;
      }));
  }

  commitNegotiate(body: any) {
    return this.apiService.postUpload2(routes.commitNegotiate, body)
      .pipe(map(res => {
        return res;
      }));
  }

  getHistoryNegotiate(contractId: any) {
    return this.apiService.post(routes.getHistoryNegotiate  + contractId)
      .pipe(map(res => {
        return res;
      }));
  }

  downLoadFileNegotiate(path: any) {
    return this.apiService.getFile(routes.downLoadFileNegotiate + path)
      .pipe(map(res => {
        return res;
      }));
  }

  commitNegotiateAnonymous(body: any) {
    return this.apiService.postUpload2(routes.commitNegotiateAnonymous, body)
      .pipe(map(res => {
        return res;
      }));
  }

  getHistoryNegotiateAnonymous(body: any) {
    return this.apiService.post(routes.getHistoryNegotiateAnonymous, body)
      .pipe(map(res => {
        return res;
      }));
  }

  downLoadFileNegotiateAnonymous(path: any, tenantId: any) {
    return this.apiService.getFile(routes.downLoadFileNegotiateAnonymous + path +`/${tenantId}`)
      .pipe(map(res => {
        return res;
      }));
  }

  getApparamInfo(data: any){
    return this.apiService.post(routes.appParam, data).pipe(map(res => {
      return res;
    }));
  }

  filterContractShare(data: any){
    return this.apiService.postSilently(routes.filterContractShare, data).pipe(map(res => {
      return res;
    }));
  }

  getListPartnerSharedById(id: any){
    return this.apiService.get(routes.getListPartnerSharedById + id).pipe(map(res => {
      return res;
    }));
  }

  updateListPartnerShared(body: any){
    return this.apiService.post(routes.updateListPartnerShared, body).pipe(map(res => {
      return res;
    }));
  }

  sendUserSignContractLot( data: any) {
    return this.apiService.post(routes.sendUserSignContractLot, data)
      .pipe(map(res => {
        return res;
      }));
  }

  checkContractTermination(id: string){
    return this.apiService.get(routes.checkContractTermination(id)).pipe(map(res => {
      return res;
    }));
  }

  checkContractTerminationCopy(id: string){
    return this.apiService.get(routes.checkContractTerminationCopy(id)).pipe(map(res => {
      return res;
    }));
  }

  downloadFileEvidence(id: string): Observable<HttpResponse<Blob>> {
    const url = routes.downloadFileEvidence(id);
    return this.http.get(url, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  getInfoFile(body: any){
    return this.apiService.postUpload2(routes.getInfoFile, body).pipe(map(res => {
      return res;
    }));
  }

  getListSms(body: any) {
    return this.apiService.post(routes.getListSmsTemplates, body).pipe(map(res => {
      return res;
    }));
  }
}
